export const TEXT = {
    MY_GROUPS: 'My Groups',
    TOTAL_MEDIA: 'total media: ',
    IMAGES: 'images',
    VIDEOS: 'videos',
    JOIN_GROUP: 'Join Group',
    CREATE_GROUP: '+ Create Group'
}